import { esNativo } from '../config/entorno';
import { guardarTokenNativo, abrirRutaDesdeWidget } from './authNativo';
import { registrarNavegacionPush } from '../utils/pushNotifications';

export async function initNativo(router) {
  if (!esNativo()) return;

  document.documentElement.classList.add('nativo-android');
  guardarTokenNativo(localStorage.getItem('token') || '');

  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    await StatusBar.setOverlaysWebView({ overlay: false });
    await StatusBar.setBackgroundColor({ color: '#F4F6F3' });
    await StatusBar.setStyle({ style: Style.Light });
  } catch (err) {
    console.warn('No se pudo configurar la barra de estado', err);
  }

  try {
    const { Keyboard, KeyboardResize } = await import('@capacitor/keyboard');
    await Keyboard.setResizeMode({ mode: KeyboardResize.Body });
  } catch (err) {
    console.warn('No se pudo configurar el teclado nativo', err);
  }

  try {
    const { App } = await import('@capacitor/app');
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack || window.history.length > 1) {
        window.history.back();
        return;
      }
      App.exitApp();
    });
    App.addListener('appUrlOpen', ({ url }) => {
      abrirRutaDesdeWidget(url, router);
    });
    const launch = await App.getLaunchUrl();
    if (launch && launch.url) {
      abrirRutaDesdeWidget(launch.url, router);
    }
  } catch (err) {
    console.warn('No se pudo registrar el botón atrás', err);
  }

  registrarNavegacionPush((url) => {
    const ruta = String(url || '/');
    if (ruta.startsWith('/')) router.push(ruta);
  });

  try {
    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.hide();
  } catch (err) {
    console.warn('No se pudo ocultar el splash', err);
  }
}
